var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMidnight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m280 96a40 40 0 0 1 -63.63 32.27 72.011 72.011 0 0 1 -128.74 0 40 40 0 1 1 0-64.54 72.011 72.011 0 0 1 128.74 0 40 40 0 0 1 63.63 32.27z",
    fill: "#606669"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f7b030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m488 80s-40 8-40 56c0-48-40-56-40-56s40-8 40-56c0 48 40 56 40 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 424s-24 8-24 40c0-32-24-40-24-40s24-8 24-40c0 32 24 40 24 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 232h-8v-16a8 8 0 0 0 -16 0v16h-8a8 8 0 0 0 0 16h8v16a8 8 0 0 0 16 0v-16h8a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 400q4.605 0 9.13-.32a176 176 0 1 1 0-255.36q-4.53-.315-9.13-.32a128 128 0 0 0 0 256z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m488 408a56.006 56.006 0 0 1 -92.31 42.64 80 80 0 0 1 -135.38 0 56 56 0 1 1 0-85.28 80 80 0 0 1 135.38 0 56.006 56.006 0 0 1 92.31 42.64z",
    fill: "#606669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidnight);
export default __webpack_public_path__ + "static/media/midnight.e1fbfdac61f3ef8711752b5b244fdc6d.svg";
export { ForwardRef as ReactComponent };